export default class ExternLink {
  constructor() {
    this.links = document.querySelectorAll("body a:not([target='_blank'])");
    this.rawSiteLink = window.location.href;
    this.siteLink = this.clearUrl(this.rawSiteLink);

    this.setPdfs();
    this.setExternLinks();
  }

  setExternLinks() {
    this.links.forEach((link) => {
      const href = this.clearUrl(link.href);
      if (href !== null &&href !== '' && href !== this.siteLink) {
        link.setAttribute("target", "_blank");
      }
    });
  }

  setPdfs() {
    this.links.forEach((link) => {
      const href = link.href.slice(-5);
      if (href.includes(".pdf")) {
        link.setAttribute("target", "_blank");
      }
    });
  }

  clearUrl(link) {
    //remove http
    link = link.split("//");
    if (link[0].includes("http")) link.shift();

    //remove after /
    link = link.toString().split("/");
    link = link[0].toString();

    if (link.includes("www.")) link = link.split("www.")[1].toString();

    return link;
  }
}
